export default __webpack_public_path__ + "static/media/logo-waysbucks.307692da.svg";